import type { FaireProductEntity } from "../../entity_types/product";

export const p_yyyrwu9643: FaireProductEntity = {
  token: "p_yyyrwu9643",
  type: "product",
  name: "LM-BG-1004 REUSABLE TOTE -WHITE CAMO",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/f8c7e561d80d0ea584e8f20b8d6ac936935aa625bd45e619d8162289804a9e9b.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.5,
  description: "This reusable tote from Girlie Girl Originals offers a practical way to carry essentials with everyday ease. Designed for durability and convenience, the white camo pattern adds versatile style, making it a suitable accessory for daily use.",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:51.551Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
